export default __webpack_public_path__ + "static/media/misc-pantry2-1024w.377a95cb.avif";